import { render, staticRenderFns } from "./DatatableUsers.vue?vue&type=template&id=1dce61fb"
import script from "./DatatableUsers.vue?vue&type=script&lang=js"
export * from "./DatatableUsers.vue?vue&type=script&lang=js"
import style0 from "./DatatableUsers.vue?vue&type=style&index=0&id=1dce61fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports